import React, { Fragment } from "react";

import { IEntitlementsData } from "../../types/misc.interface";

const formatTitles = (items?: { title: string }[]) => {
    if (!items?.length) return '-';
    return items.map(item => item.title).join(`\n`);
};

interface IEntitlementTableCellsProps {
    entitlements: IEntitlementsData;
};

export const EntitlementTableHeaderCells = () => (
    <Fragment>
        <th><p className="text-xs text-medium color--txt-disabled text-left text-center">Products Access</p></th>
        <th><p className="text-xs text-medium color--txt-disabled text-left text-center">STAGE Modules</p></th>
        <th><p className="text-xs text-medium color--txt-disabled text-left text-center">STAGE Assessments</p></th>
        <th><p className="text-xs text-medium color--txt-disabled text-left text-center">ATLAS Modules</p></th>
        <th><p className="text-xs text-medium color--txt-disabled text-left text-center">ATLAS Assessments</p></th>
    </Fragment>
);

export const EntitlementTableCells = ({ entitlements }: IEntitlementTableCellsProps) => (
    <Fragment>
        <td><p className="text-sm color--txt-muted text-center whitespace-pre-line">{formatTitles(entitlements.products)}</p></td>
        <td><p className="text-sm color--txt-muted text-center whitespace-pre-line">{formatTitles(entitlements.mbts_modules)}</p></td>
        <td><p className="text-sm color--txt-muted text-center">{entitlements.mbts_assessments ?? '-'}</p></td>
        <td><p className="text-sm color--txt-muted text-center whitespace-pre-line">{formatTitles(entitlements.mcsa_modules)}</p></td>
        <td><p className="text-sm color--txt-muted text-center">{entitlements.mcsa_assessments ?? '-'}</p></td>
    </Fragment>
);